import type { Fallacy } from "./types";
import { createStory } from "./types";

export const normalcyBias: Fallacy = {
    id: "normalcy-bias",
    name: "Normalcy Bias",
    emoji: "🙈",
    category: "Otak yang Menipu Diri",
    description: "**Meremehkan tanda-tanda bahaya** karena menganggap semuanya akan **baik-baik saja seperti biasa**.",
    tldr: "\"Nggak mungkin terjadi di sini\" — sampai beneran terjadi.",
    detail: "Normalcy Bias adalah kecenderungan untuk percaya bahwa **segala sesuatu akan terus berjalan normal**, bahkan ketika ada bukti jelas bahwa situasi berbahaya sedang berkembang. Bias ini menjelaskan mengapa orang tidak mengungsi meskipun ada peringatan bencana, atau mengapa perusahaan gagal beradaptasi meskipun **disrupsi industri sudah terlihat jelas**.\n\nStudi menunjukkan saat bencana terjadi, **sekitar 70% orang mengalami normalcy bias** — mereka freeze atau melanjutkan aktivitas normal alih-alih mengambil tindakan.\n\nDi dunia bisnis, normalcy bias adalah **pembunuh inovasi**. Nokia, Kodak, dan Blockbuster semuanya menganggap ancaman baru \"gak bakal populer\" — sampai terlambat.\n\nCara melawan: Buat **rencana darurat saat kondisi masih normal**. Dengarkan warning signals meskipun terasa tidak mungkin. Tanya: \"Bagaimana kalau ini benar-benar terjadi?\"",
    story: createStory("Normalcy Bias", "🙈", {
      hook: {
        title: "\"Gak mungkin terjadi di sini.\"",
        body: "Kalimat terakhir sebelum sesuatu beneran terjadi.",
      },
      convo: {
        claim: "Kompetitor udah launch versi AI dan user kita mulai pindah, tapi aku gak khawatir. **Pelanggan kita loyal**, kita udah 10 tahun di market.",
        response: "Nokia juga bilang gitu sebelum iPhone dateng. **Loyalitas gak abadi.**",
      },
      reveal: {
        body: "Otak kamu **meremehkan tanda bahaya** karena nganggep semuanya bakal **baik-baik aja kayak biasa**. 70% orang freeze saat bencana terjadi — karena bias ini.",
      },
      insight: {
        title: "Kenapa bahaya banget?",
        body: "Nokia, Kodak, Blockbuster — semua bilang \"gak bakal populer\". Normalcy bias bikin kamu **lambat bereaksi sampai terlambat**.",
      },
      engagement: {
        title: "Pernah nyesel karena terlalu santai menanggapi warning?",
        body: "Soal karir, kesehatan, atau keuangan? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["status-quo-bias", "appeal-to-tradition", "loss-aversion", "availability-heuristic"],
  };
